import React from 'react';
import { MenuItem } from '@mui/material';

const useFontFamilies = (type = 'option') => {
  const fonts = [
    { value: "Arial", label: "Arial" },
    { value: "Verdana", label: "Verdana" },
    { value: "Times New Roman", label: "Times New Roman" },
    { value: "Courier New", label: "Courier New" },
    { value: "Georgia", label: "Georgia" },
    { value: "GothamMedium", label: "Gotham Medium" },
    { value: "Gothambook", label: "Gotham Book" },
    { value: "playfairdisplay", label: "Playfair Display Regular" },
    { value: "IBMPlexSans-Bold", label: "IBMPlexSans-Bold" },
    { value: "IBMPlexSans-Medium", label: "IBMPlexSans-Medium" },
    { value: "IBMPlexSans-Regular", label: "IBMPlexSans-Regular" },
    { value: "IBMPlexSans-SemiBold", label: "IBMPlexSans-SemiBold" },
    { value: "IBMPlexSans-Thin", label: "IBMPlexSans-Thin" },
    { value: "georgia-normal", label: "Georgia Normal" },
    { value: "brandon-grotesque-bold", label: "Brandon Grotesque Bold" },
    { value: "brandon-grotesque-black", label: "Brandon Grotesque Black" },
    { value: "NeueFrutigerWorld-Black", label: "Neue Frutiger World Black" },
    { value: "NeueFrutigerWorld-Bold", label: "Neue Frutiger World Bold" },
    { value: "NeueFrutigerWorld-Book", label: "Neue Frutiger World Book" },
    { value: "NeueFrutigerWorld-Heavy", label: "Neue Frutiger World Heavy" },
    { value: "NeueFrutigerWorld-It", label: "Neue Frutiger World Italic" },
    { value: "NeueFrutigerWorld-Light", label: "Neue Frutiger World Light" },
    { value: "NeueFrutigerWorld-Medium", label: "Neue Frutiger World Medium" },
    { value: "NeueFrutigerWorld-Regular", label: "Neue Frutiger World Regular" },
    { value: "NeueFrutigerWorld-Thin", label: "Neue Frutiger World Thin" },
    { value: "NeueFrutigerWorld-XtraBlk", label: "Neue Frutiger World Extra Black" },
    { value: "BebasNeue-Regular", label: "Bebas Neue Regular" },
    { value: "Figtree", label: "FigTree Regular - Boston" },
    { value: "Figtree-Italic", label: "FigTree Italic - Boston" },
    { value: "Figtree-Light", label: "FigTree Light - Boston" },
    { value: "Figtree-LightItalic", label: "FigTree Light Italic - Boston" },
    { value: "Figtree-Medium", label: "FigTree Medium - Boston" },
    { value: "Figtree-MediumItalic", label: "FigTree Medium Italic - Boston" },
    { value: "Figtree-SemiBold", label: "FigTree SemiBold - Boston" },
    { value: "Figtree-SemiBoldItalic", label: "FigTree SemiBold Italic - Boston" },
    { value: "Figtree-Bold", label: "FigTree Bold - Boston" },
    { value: "Figtree-BoldItalic", label: "FigTree Bold Italic - Boston" },
    { value: "Figtree-ExtraBold", label: "FigTree ExtraBold - Boston" },
    { value: "Figtree-ExtraBoldItalic", label: "FigTree ExtraBold Italic - Boston" },
    { value: "Figtree-Black", label: "FigTree Black - Boston" },
    { value: "Figtree-BlackItalic", label: "FigTree Black Italic - Boston" }
  ];

  if (type === 'menuitem') {
    return fonts.map(font => (
      <MenuItem key={font.value} value={font.value}>
        {font.label}
      </MenuItem>
    ));
  }

  if (type === 'array') {
    return fonts;
  }

  return fonts.map(font => (
    <option key={font.value} value={font.value}>
      {font.label}
    </option>
  ));
};

export default useFontFamilies;
